import React from 'react';
import './ComingSoon.css';

const SimpleComingSoon = () => {
  return (
    <div className="container">
      <h1 className="title">Coming Soon</h1>
      <div className="icon">🌟</div>
    </div>
  );
};

export default SimpleComingSoon;